import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { LoadingSpinnerComponent } from '@archimed/refinery-model-exploration';
import {
  AppShellComponent,
  HeaderAppLogoDirective,
  HeaderAppNameComponent,
  HeaderComponent,
  HeaderEndDirective,
  IconButtonComponent,
  IconComponent,
} from '@totalenergiescode/tds-angular';
import { map } from 'rxjs';
import { AuthenticationService } from './core/services/authentication.service';
import { LoadingService } from './core/services/loading.service';
import { NavigationComponent } from './shell/components/navigation/navigation.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    AppShellComponent,
    HeaderComponent,
    HeaderAppNameComponent,
    HeaderEndDirective,
    HeaderAppLogoDirective,
    IconComponent,
    IconButtonComponent,
    NavigationComponent,
    LoadingSpinnerComponent,
  ],
  selector: 'app-root',
  standalone: true,
  styleUrls: ['./app.scss'],
  templateUrl: './app.html',
})
export class App {
  private readonly authenticationService = inject(AuthenticationService);
  protected readonly isLoading = inject(LoadingService).isLoading;

  userName = toSignal(
    this.authenticationService.connectedUser.pipe(
      map((user) => user?.displayName || user?.username || 'Guest'),
    ),
    { initialValue: 'Loading...' },
  );
  currentLanguage = 'EN';

  onProfileClick(): void {
    console.log('Profile clicked');
  }

  onHelpClick(): void {
    console.log('Help clicked');
  }

  onNotificationsClick(): void {
    console.log('Notifications clicked');
  }

  onLanguageChange(): void {
    console.log('Language changed');
  }
}
